/**
 * 生徒ページ用のローカル保存。
 *
 * 採点結果そのものは既存の `storage.js`（きろく）に入れるので、ここでは扱わない。
 * ここが持つのは「どの課題を開いたことがあるか」だけ。
 *
 * ⚠️ サーバー（submissions）から履歴は読めない。SELECTを課題の作成者だけに
 *    絞っているため。緩めるとクラス全員の名前と点数が誰でも見られる状態になる。
 *
 * 2026-08-19：childId単位で保存するように変更（きょうだいで端末を共有すると
 * 課題一覧が混ざっていたため）。childId不明時は 'shared' キーにまとめる。
 */

const CODES_KEY = 'ondoku_student_codes';      // { [childId]: string[] }（開いたことのある課題コード）
const LAST_NAME = 'ondoku_student_last_name';  // 直近に使った名前（次回の入力を省くため）

const read = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)); }
  catch { return fallback; }
};

const keyFor = (childId) => childId || 'shared';

/** 開いた課題コードを覚える（子どもごと・新しい順・最大30件） */
export function rememberCode(code, childId) {
  if (!code) return;
  const all = read(CODES_KEY, {});
  const k = keyFor(childId);
  const codes = (all[k] || []).filter((c) => c !== code);
  codes.unshift(code);
  all[k] = codes.slice(0, 30);
  localStorage.setItem(CODES_KEY, JSON.stringify(all));
}

export function getCodes(childId) {
  const all = read(CODES_KEY, {});
  return all[keyFor(childId)] || [];
}

export function getLastName() {
  return localStorage.getItem(LAST_NAME) || '';
}

export function rememberName(name) {
  if (name) localStorage.setItem(LAST_NAME, name);
}
